export default __webpack_public_path__ + "media/landscape/logo_shutterstock-a0dcaac3.svg";